import React from 'react';
import PropTypes from 'prop-types';

import ChatSuggestion from './ChatSuggestion';

function formatPractitionerName(practitioner) {
  if (practitioner.family || practitioner.given) {
    return [practitioner.family, practitioner.given].filter(Boolean).join(', ');
  }
  return practitioner.name || '';
}

function ChatSuggestions({
  practitioners,
  loading,
  error,
  searchQuery,
  onBeginCreation,
}) {
  if (loading && practitioners.length === 0) {
    return <p className="pa3 ma0 silver new-chat-practitioner-list">Loading therapists...</p>;
  }

  if (error) {
    return (
      <p className="pa3 ma0 red new-chat-practitioner-list">
        Unable to load therapists. Please try again.
      </p>
    );
  }

  if (practitioners.length === 0) {
    const message = searchQuery.trim()
      ? 'No therapists match your search.'
      : 'No therapists available.';
    return <p className="pa3 ma0 silver new-chat-practitioner-list">{message}</p>;
  }

  return (
    <ul className="new-chat-practitioner-list ma0 pa0 list" aria-label="Therapists">
      {practitioners.map((practitioner) => (
        <li key={practitioner.id} className="ma0 pa0">
          <ChatSuggestion
            name={formatPractitionerName(practitioner)}
            onCreate={onBeginCreation(practitioner)}
          />
        </li>
      ))}
    </ul>
  );
}

ChatSuggestions.propTypes = {
  practitioners: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      given: PropTypes.string,
      family: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  error: PropTypes.object,
  searchQuery: PropTypes.string,
  onBeginCreation: PropTypes.func.isRequired,
};

ChatSuggestions.defaultProps = {
  practitioners: [],
  loading: false,
  error: null,
  searchQuery: '',
};

export default ChatSuggestions;
